import styled from "styled-components";
import { ButtonGroup } from "@songtradr/component-library";

// TEXT

// STYLES
export const RightSideButtonGroup = styled(ButtonGroup)`
  justify-content: end;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
